import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Spinner,
  InputGroup,
} from "react-bootstrap";

import { useNavigate, useLocation } from "react-router-dom"; // ✅ v6
import { useSelector, useDispatch } from "react-redux";
import { sendLogin, userAutoLogin } from "../../pages/admin-login/loginAction";

const initialState = {
  email: process.env.REACT_APP_EMAIL || "",
  password: process.env.REACT_APP_PASS || "",
};

export const AdminLoginComp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // ✅ replaced useHistory
  const location = useLocation(); // ✅ replaced history.location
  const [login, setLogin] = useState(initialState);
  const [show, setShow] = useState(false);

  const { isLoading } = useSelector((state) => state.login);
  const { isAuth } = useSelector((state) => state.user);

  const from = location.state?.from || "/dashboard"; // ✅ updated

  useEffect(() => {
    if (isAuth) {
      navigate(from, { replace: true }); // ✅ replaced history.replace
    } else {
      dispatch(userAutoLogin());
    }
  }, [isAuth, navigate, from, dispatch]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setLogin({
      ...login,
      [name]: value,
    });
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();

    if (!login.email || !login.password) {
      return alert("Fill up the form");
    }

    dispatch(sendLogin(login));
    navigate("/dashboard"); // ✅ replaced history.push
  };

  return (
    <Container>
      <Row>
        <Col>
          <h2 className="text-danger text-center">
            Welcome to Dented Code Academy Admin Login
          </h2>
          <hr />
          {isLoading && <Spinner variant="primary" animation="border" />}

          <Form autoComplete="off" onSubmit={handleOnSubmit}>
            <Form.Group>
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={login.email}
                placeholder="Enter your email"
                required
                onChange={handleOnChange}
              />
            </Form.Group>

            <Form.Group controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <InputGroup
                className="input mb-3"
                style={{
                  alignItems: "center",
                  border: "1px solid #aaa",
                  borderRadius: "3px",
                  color: "#333",
                  display: "flex",
                }}
              >
                <Form.Control
                  className="form"
                  type={show ? "text" : "password"}
                  value={login.password}
                  name="password"
                  placeholder="Enter your password"
                  required
                  style={{ border: "0px solid #aaa", outline: "0" }}
                  onChange={handleOnChange}
                />
                <button
                  type="button"
                  style={{
                    cursor: "pointer",
                    margin: "0 10px",
                    border: "none",
                    background: "none",
                  }}
                  onClick={() => setShow(!show)}
                >
                  {show ? (
                    <i className="far fa-eye" />
                  ) : (
                    <i className="far fa-eye-slash" />
                  )}
                </button>
              </InputGroup>
            </Form.Group>

            <Button className="mt-3" variant="primary" type="submit">
              Submit
            </Button>
          </Form>

          <hr />
          <a
            href="#@"
            onClick={() => navigate("/reset-password")} // ✅ replaced history.push
            style={{
              textDecoration: "none",
              color: "red",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              marginBottom: 20,
            }}
          >
            Forgot password
          </a>
        </Col>
      </Row>
    </Container>
  );
};
